import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { ClientSettingsModule } from '../client-settings/client-settings';
import { CookiesModule } from '../cookies/cookies';
import { LoggerModule } from '../logger/logger';
import { WindowRefModule } from '../window-ref/window-ref';
import { HttpRequestInterceptor } from './interceptor/http-request.interceptor';

@NgModule({
  declarations: [],
  exports: [],
  imports: [ClientSettingsModule, LoggerModule, CookiesModule, WindowRefModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class HttpRequestModule {}
